import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import newService from "../../../services/newService";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const New = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [news, setNews] = useState(null);

  useEffect(() => {
    const fetchNew = async () => {
      try {
        const res = await newService.getOneNews(instanceToken.token, id);
        setNews(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchNew();
  }, [id]);

  const handleRemove = async () => {
    try {
      await newService.deleteNews(instanceToken.token, id);
      homeAlert("New post have been removed.", false);
      navigate("/all_news");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <DetailPageLayout
      title="News Details"
      subtitle="View and manage news or knowledge content"
      breadcrumbs={[
        { label: "News", path: "/all_news" },
        { label: `News (ID - ${id})` },
      ]}
      listPath="/all_news"
      imageUrl={news?.image_url}
      loading={!news}
      editPath={news ? `/updateNew/${news.id}` : undefined}
      onRemove={handleRemove}
      contentSections={
        news
          ? [
              {
                title: "Paragraph (English)",
                value: news.paragraph_en,
                html: true,
                icon: "article",
              },
              {
                title: "Paragraph (Myanmar)",
                value: news.paragraph_mm,
                html: true,
                myanmar: true,
                icon: "article",
              },
            ]
          : []
      }
      infoItems={
        news
          ? [
              { label: "ID", value: String(news.id), icon: "id" },
              {
                label: "Category",
                value: news.category,
                icon: "category",
                badge: "category",
              },
              {
                label: "Title (English)",
                value: news.title_en,
                icon: "title",
              },
              {
                label: "Title (Myanmar)",
                value: news.title_mm,
                icon: "title",
                myanmar: true,
              },
              ...dateInfoItems(news),
            ]
          : []
      }
      quickActions={
        news?.image_url
          ? [
              {
                label: "Preview Image",
                onClick: () => window.open(news.image_url, "_blank", "noreferrer"),
              },
            ]
          : []
      }
    />
  );
};

export default New;
